module.exports = __webpack_public_path__ + "static/homepage-thumbnail-ad9d49716d5d18b4c6f7906d5058fda4.jpg";